import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import { Entity, EntityAuthorization, getSelectedEntity } from '../../redux/EntitySlice';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { selectUserRole } from '../../redux/UserSlice';
import utilityHelper from '../../utils/utilityHelper';
import ToastReporter from './ToastReporter';

const ContactsReporter = (props: any) => {

    //selectors
    var entity: Entity | null = useAppSelector(getSelectedEntity);
    var tType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    const userRoleSelector = useAppSelector(selectUserRole);
    var afr: Afr | null = useAppSelector(getSelectedAfr);

    //hooks
    const [detailData, setDetailData] = React.useState<any>([]);

    //use effects
    React.useEffect(() => {

        if (entity) {
            if (entity.contacts && entity.contacts.length > 0) {

                var workingContactList: Array<{ key: string, value: string }> = [];

                for (var i = 0; i < entity.contacts.length; i++) {

                    var foundEntityAuthorization = entity.contacts[i].entityAuthorizations.find((item: EntityAuthorization) => tType && item.reportAccess == tType.toString());

                    if (foundEntityAuthorization) {

                        var contactRole: string = utilityHelper.SnakeCaseToTitleCase(foundEntityAuthorization.entityContactRole);
                        var entityUserRole: string = utilityHelper.SnakeCaseToTitleCase(foundEntityAuthorization.entityUserRole);

                        workingContactList.push({
                            key: contactRole + " " + entityUserRole,
                            value: entity.contacts[i].contact.firstName + " " + entity.contacts[i].contact.lastName
                        });
                    }
                }

                setDetailData(workingContactList);
            }
            else {
                setDetailData([]);
            }
        }
        else {
            setDetailData([]);
        }

    }, [entity])

    return (
        <div>
            {
                ((userRoleSelector) && userRoleSelector == "ADMIN") && entity != null && afr != null && detailData.length > 0 ?
                    <ToastReporter topic="Contacts" style="" details={detailData} showReadMoreMaxChars={0} />
                    : (<div></div>)
            }
        </div>
    )
}

export default ContactsReporter;